import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import {
  selectAreFiltersAvailable,
  selectIsHotel,
  selectRoomFilters,
} from '@store/hotel-availability/hotel-availability.selectors';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { RoomFilter } from '@core/models/room-filter/room-filter';
import {
  changeRoomFilter,
  resetFilters,
} from '@store/hotel-availability/hotelAvailability.actions';
import { tap } from 'rxjs/operators';
import { MbIconModule } from '@am/moebius';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'am-room-filters-responsive',
    templateUrl: './room-filters.component.html',
    styleUrls: ['./room-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MbIconModule,
        AsyncPipe,
    ],
})
export class RoomFiltersComponent implements OnInit {
  public filters$: Observable<RoomFilter[]>;
  public isHotel$: Observable<boolean>;
  public areFiltersAvailable$: Observable<boolean>;
  public someFilterActive$: Subject<boolean> = new BehaviorSubject(false);

  constructor(private readonly store: Store<AppState>) {
    this.filters$ = this.store.select(selectRoomFilters).pipe(
      tap((filters: RoomFilter[]) => {
        this.someFilterActive$.next(filters.some(f => f.active));
      }),
    );
    this.isHotel$ = this.store.select(selectIsHotel);
    this.areFiltersAvailable$ = this.store.select(selectAreFiltersAvailable);
  }

  ngOnInit(): void {}

  public onFilterClick(filter: RoomFilter) {
    if (!filter.disabled) {
      filter.active = !filter.active;
      this.store.dispatch(changeRoomFilter({ filter }));
    }
  }

  public resetFilters() {
    this.store.dispatch(resetFilters());
  }

  get someFilterActive(): Observable<boolean> {
    return this.someFilterActive$.asObservable();
  }
}
